import FormatUtil from '../utils/format'
import DateUtil from '../utils/date'

export default function (SkyFoxVue) {

  SkyFoxVue.filter('capitalize', function (val) {
    return FormatUtil.capitalize(val)
  })

  SkyFoxVue.filter('camelize', function (val) {
    return FormatUtil.camelize(val)
  })

  SkyFoxVue.filter('number_format', function (val, defaultVal) {
    return FormatUtil.formatNumber(val, defaultVal)
  })

  SkyFoxVue.filter('percentage_format', function (val, defaultVal, withSign) {
    val = FormatUtil.percentage(val, defaultVal)
    return withSign ? val + '%' : val
  })

  SkyFoxVue.filter('date_format', function (date, srcFormat, dstFormat) {
    if (arguments.length <= 2) {
      return DateUtil.format(date, srcFormat)
    } else {
      return DateUtil.changeFormat(date, srcFormat, dstFormat)
    }
  })

  SkyFoxVue.filter('html_format', function (val, nl2br = true, enableLink = false) {
    return FormatUtil.escapeHtml(val, {
      nl2br,
      enableLink
    })
  })

  SkyFoxVue.filter('percentage', function (val, fractionDigits = 0) {
    return FormatUtil.percentage(val, fractionDigits)
  })

  SkyFoxVue.filter('file_size', function (fileSizeByte) {
    return FormatUtil.fileSize(fileSizeByte)
  })

  return SkyFoxVue
}



// WEBPACK FOOTER //
// ./src/extentions/filters.js